import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, Tenant, SearchTenantRequest, SaveTenantDto, MenuFuncionTenant, TenantDiccionarioDto, TenantFeatureFlags, FeatureFlag } from "../model/index";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})
export class TenantService extends CrudService<Tenant, number, SaveTenantDto, SearchTenantRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'tenant', sharedFunctions);

  }

  getAllFeatureFlags(): Observable<GenericResponse<FeatureFlag[]>> {
    return this._http.get<GenericResponse<FeatureFlag[]>>(this._serviceUrl + '/feature-flags/all', this.httpOptions);
  }

  getTenantFeatureFlagsById(id: number): Observable<GenericResponse<TenantFeatureFlags>> {
    return this._http.get<GenericResponse<TenantFeatureFlags>>(this._serviceUrl + '/' + id + '/feature-flags', this.httpOptions);
  }

  getTenantFeatureFlagsByLoggedUserId(): Observable<GenericResponse<TenantFeatureFlags[]>> {
    return this._http.get<GenericResponse<TenantFeatureFlags[]>>(this._serviceUrl + '/feature-flags', this.httpOptions);
  }

  getTenantMenusById(id: number): Observable<GenericResponse<MenuFuncionTenant[]>> {
    return this._http.get<GenericResponse<MenuFuncionTenant[]>>(this._serviceUrl + '/' + id + '/menus', this.httpOptions);
  }

  getTenantDiccionarioById(id: number): Observable<GenericResponse<TenantDiccionarioDto[]>> {
    return this._http.get<GenericResponse<TenantDiccionarioDto[]>>(this._serviceUrl + '/' + id + '/diccionario', this.httpOptions);
  }

  getTenantDiccionarioSimplificadoById(id: number): Observable<GenericResponse<Record<string | null, string>>> {
    return this._http.get<GenericResponse<Record<string | null, string>>>(this._serviceUrl + '/' + id + '/diccionario-simplificado', this.httpOptions);
  }

  getAnonymousList(): Observable<GenericResponse<Tenant[]>> {
    return this._http.get<GenericResponse<Tenant[]>>(this._serviceUrl+"/anonymous", this.httpOptions);
  }
}